<template>
    <div class="completed-checkbox" v-if="isLoggedIn">
        <TotemToggleButton v-model="showCompletedCheckbox" :label="buttonLabel" :editable="editable" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'totem-completed-checkbox',
        props: {
            value: Boolean,
            label: String,
            editable: Boolean
        },
        data () {
            return {
                showCompletedCheckbox: true
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                getCompletedCheckbox: 'CourseFilter/getCompletedCheckbox'
            }),
            buttonLabel () {
                return this.label ? this.label : this.$t('TotemCompletedCheckbox.show_completed_courses')
            }
        },
        watch: {
            showCompletedCheckbox () {
                this.$emit('input', this.showCompletedCheckbox)
            }
        },
        created () {
            this.currentPackageSlug = this.$route.params.packageSlug

            if (this.getCompletedCheckbox && this.getCompletedCheckbox.id === this.currentPackageSlug && this.$route.name === 'course-list') {
                this.showCompletedCheckbox = this.getCompletedCheckbox.value
            }
        },
        beforeDestroy () {
            if (this.$route.name === 'course-list-course-page' || this.$route.name === 'course-list-course-page-live') {
                this.$store.dispatch('CourseFilter/assignCompletedCheckbox', {
                    id: this.currentPackageSlug,
                    value: this.showCompletedCheckbox
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .completed-checkbox {
        width: 285px;
        margin: 0;
    }
</style>
